/**
 * Centralized URL query-parameter names used across pages.
 *
 * Producers and consumers must reference these constants rather than
 * hardcoding the literal string so a rename here propagates everywhere.
 */
export const CREATE_FLAG_PARAM = 'create';
